import Vue from 'vue'
import Router from 'vue-router'

//登录
const Login = () => import('./views/Login.vue');
const Cashier = () => import('./views/Cashier.vue');
//忘记密码
const Forget = () => import('./views/Forget.vue');
//支付
const Pay = () => import('./views/Pay.vue');
const AnonymousPay = () => import('./views/AnonymousPay.vue');//匿名支付
const PayResult = () => import('./views/PayResult.vue');
//问题设置
const Question = () => import('./views/Question.vue');
const NotFind = () => import('./views/NotFind.vue');
const Home = () => import('./views/Home.vue');
const Charge = () => import('./views/Charge.vue');
const Bill = () => import('./views/Bill.vue');
const My = () => import('./views/My.vue');
//支付顺序
const PayOrder = () => import('./views/PayOrder.vue');
//密码设置
const Password = () => import('./views/Password.vue');
//充值设置
const ChargeSet = () => import('./views/ChargeSet.vue');
const ChargeResult = () => import('./views/ChargeResult.vue');
//交易限额
const Limit = () => import('./views/Limit.vue');
//问题设置
const QuestionSet = () => import('./views/QuestionSet.vue');
//银行卡
const BankCard = () => import('./views/BankCard.vue');
//免密支付
const AvoidClose = () => import('./views/AvoidClose.vue');
const AgreementsSuccess = () => import('./views/AgreementsSuccess.vue');
const AgreementsError = () => import('./views/AgreementsError.vue');
//重大修改密码
const CdPassword = () => import('./views/CdPassword.vue');
const CdPasswordResult = () => import('./views/CdPasswordResult.vue');

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/cashier-pc/',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {isLogin: false,},
            beforeEnter: (to, from, next) => {
                let token = localStorage.getItem('cashier-pc-v2-token');
                if (token) {
                    next({path: '/'});
                }else{
                    next();
                }
            }
        },
        {
            path: '/cashier',
            name: 'cashier',
            component: Cashier,
            meta: {isLogin: false,}
        },
        {
            path: '/question',
            name: 'question',
            component: Question,
            meta: {isLogin: false,}
        },
        {
            path: '/pay',
            name: 'pay',
            component: Pay,
            meta: {isLogin: false,}
        },
        {
            path: '/anonymousPay',
            name: 'anonymousPay',
            component: AnonymousPay,
            meta: {isLogin: false,}
        },
        {
            path: '/payResult',
            name: 'payResult',
            component: PayResult,
            meta: {isLogin: false,}
        },
        {
            path: '/',
            name: 'home',
            redirect: '/charge',
            component: Home,
            meta: {isLogin: true,},
            children: [
                {
                    path: 'charge',
                    name: 'charge',
                    component: Charge,
                    meta: {isLogin: true}
                },
                {
                    path: 'chargeResult',
                    name: 'chargeResult',
                    component: ChargeResult,
                    meta: {isLogin: false}
                },
                {
                    path: 'bill',
                    name: 'bill',
                    component: Bill,
                    meta: {isLogin: true}
                },
                {
                    path: 'my',
                    name: 'my',
                    component: My,
                    meta: {isLogin: true}
                },
                {
                    path: 'payOrder',
                    name: 'payOrder',
                    component: PayOrder,
                    meta: {isLogin: true}
                },
                {
                    path: 'password',
                    name: 'password',
                    component: Password,
                    meta: {isLogin: true}
                },
                {
                    path: 'chargeSet',
                    name: 'chargeSet',
                    component: ChargeSet,
                    meta: {isLogin: true}
                },
                {
                    path: 'bankCard',
                    name: 'bankCard',
                    component: BankCard,
                    meta: {isLogin: true}
                },
                {
                    path: 'limit',
                    name: 'limit',
                    component: Limit,
                    meta: {isLogin: true}
                },
                {
                    path: 'questionSet',
                    name: 'questionSet',
                    component: QuestionSet,
                    meta: {isLogin: true}
                },
                {
                    path: 'avoidClose',
                    name: 'avoidClose',
                    component: AvoidClose,
                    meta: {isLogin: true}
                },
                {
                    path: '/agreementsSuccess',
                    name: 'agreementsSuccess',
                    component: AgreementsSuccess,
                    meta: {isLogin: false}
                },
                {
                    path: '/agreementsError',
                    name: 'agreementsError',
                    component: AgreementsError,
                    meta: {isLogin: false}
                },
                {
                    path: '/cdPassword',
                    name: 'cdPassword',
                    component: CdPassword,
                    meta: {isLogin: true}
                },
                {
                    path: '/cdPasswordResult',
                    name: 'cdPasswordResult',
                    component: CdPasswordResult,
                    meta: {isLogin: true}
                },
            ]
        },
        {
            path: '/forget',
            name: 'forget',
            component: Forget,
            meta: {isLogin: false,}
        },
        {
            path: '*',
            name: '404',
            component: NotFind,
            meta: {isLogin: false,}
        },
    ]
});

// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
    if(to.meta.title){
        document.title = to.meta.title;
    }
    if (to.meta.isLogin) {
        let token = localStorage.getItem('cashier-pc-v2-token');
        if (token) {
            next()
        } else {
            next({path: '/login', query: {redirectUrl: encodeURI(to.fullPath)}});
        }
    } else {
        next()
    }
});

export default router;
